module.exports = __webpack_public_path__ + "static/media/Model-Buttons-ZoomOut.c09b754e.svg";